import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitDiscovery = (payload) =>
  axios.post(`${API}/discovery/submit`, payload).then((r) => r.data);

export const loadOperatorSubmissions = (token) =>
  axios
    .get(`${API}/operator/submissions`, { headers: { "X-Operator-Token": token } })
    .then((r) => r.data);
